import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from './app.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig, authConfig, AuthenticationService } from './authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { ConstantsUrl } from './utils/constURL';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})

export class App implements OnInit, OnDestroy {
  logoutDisplay = 'none';
  isMenuCollapsed: boolean = false;
  oauthDetails: any = { config: null, discoverDocument: null };
  clientForSSO: any[] = ["fifa", "credentia"];
  isSso: boolean = false;
  isCredentia: boolean = false;
  constructor(private _state: GlobalState,
    private _imageLoader: BaImageLoaderService,
    private _spinner: BaThemeSpinner,
    private themeConfig: BaThemeConfig,
    private router: Router, private activatedRoute: ActivatedRoute,
    private _oauth: OAuthService, private _authService: AuthenticationService,
    private http: HttpClient) {


    this.themeConfig.config();
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });

    setTimeout(console.log.bind(console, "%cSTOP!", "font: 4em sans-serif; color: red; "));
    setTimeout(console.log.bind(console, "%cYou are attempting to activate a browser feature intended for developers. If you attempt to enable unauthorized Examroom features, you will be reported to your instructor, school or exam sponsor. Additionally, by accessing this feature you have activated a bot intended to track your IP location and Device ID. This incident will be logged and reported.", "font: 2em sans-serif; color: black;"));
    setTimeout(console.log.bind(console, "%cSee https://www.examroom.ai/selfxss for more information.", "font: 2em sans-serif; color: black; "));

    this.activatedRoute.queryParams.subscribe((params: any) => {
      //List of clients sso
      //localhost:4200/?sso=fifa
      //examroom.ai/login/?sso=fifa;
      //localhost:8010/?sso=credentia
      if (this.clientForSSO.includes(params.sso)) {
        if (params.sso == "credentia") {
          sessionStorage.setItem("isCredentia", "true");
        }
        this.isSso = true;
        this.loadSSO();
      }
      if (params.code && params.code != "") {
        this.isSso = true;
        if (sessionStorage.isCredentia) {
          this._oauth.configure(authConfig);
        } else {
          this._oauth.configure(authCodeFlowConfig);
        }
        this._oauth.loadDiscoveryDocumentAndTryLogin()
          .then(() => {
            const claims = this._oauth.getIdentityClaims();
            if (claims != null || claims != undefined) {
              this.ssoLogin(claims);
            }
          })
          .catch(err => console.log(err));
      }
    });
  }

  ngOnInit(): void {

  }

  ssoLogin(claims: any) {
    let a;
    if (sessionStorage.isCredentia) {
      a = { email: claims.email, role: 10, firstName: claims.given_name, lastName: claims.family_name, ClientID: 1 }
    } else {
      a = { email: claims.uid, role: 10, firstName: claims.given_name, lastName: claims.family_name }
    }
    this.http.post(ConstantsUrl.BASE_URL + ConstantsUrl.SSO, a)
      .subscribe((data: any) => {
        if (data.Result) {
          localStorage.setItem('sso', 'true');
          // let a = data.LoginURL;
          // var res = a.replace("candidate", "testCandidate");
          // console.log(res);

          // setTimeout(() => window.open("http://localhost:8011/#/?id=kKJ09SYafrYddmwFA/8NTf1sWfWMRxZDZiJBL53Kecbqu3iYZfQy+1Y0xpQTL/bjd225kM1jw/xti7zYlH0RgQ==", '_self'), 10);
          setTimeout(() => window.open(data.LoginURL, '_self'), 10);
        }
      }, (err: any) => {
        console.log(err);
      });
  }

  async loadSSO() {
    if (sessionStorage.isCredentia) {
      this._oauth.configure(authConfig);
      let discoveryDocument = await this._oauth.loadDiscoveryDocument();
      // console.log(discoveryDocument);
      this.oauthDetails.discoveryDocument = discoveryDocument;
      // console.log(discoveryDocument.info.discoveryDocument.authorization_endpoint )
      var splitted = discoveryDocument.info.discoveryDocument.authorization_endpoint.split("oauth2", 2); 
      var newArray = splitted.push("login/oauth2")
      var temp = splitted[1];
      splitted[1] = splitted[2]
      splitted[2] = temp
      var newStr = splitted.join(' ')
      // console.log(this.removeWhitespaces(newStr))
      discoveryDocument.info.discoveryDocument.authorization_endpoint = this.removeWhitespaces(newStr);
      this._oauth.loginUrl = discoveryDocument.info.discoveryDocument.authorization_endpoint
    } else {
      this._oauth.configure(authCodeFlowConfig);
      let discoveryDocument = await this._oauth.loadDiscoveryDocument();
      this.oauthDetails.discoveryDocument = discoveryDocument;
    }
    this._oauth.initCodeFlow();
  }

  removeWhitespaces(string, i = 0, res = "") {
    if (i >= string.length)
      return res
    else
      if (string[i] == " ")
        return this.removeWhitespaces(string, i + 1, res)
      else
        return this.removeWhitespaces(string, i + 1, res += string[i])
  }

  public ngAfterViewInit(): void {
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  closeModal() {
    this.logoutDisplay = 'none';
  }

  redirect() {
    this.closeModal();
    this.router.navigateByUrl('login');
  }

  ngOnDestroy() {

  }
}
